import React, { Fragment } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Formik } from "formik";
import _ from "lodash";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import TypingFilter from "../filters/typingFilter";
import SelectDisease from "../filters/selectDisease";
import YearSelector from "../filters/yearSelector";

const styles = theme => ({
  root: {},
  button: {
    margin: theme.spacing.unit
  },
  filters: {
    paddingLeft: theme.spacing.unit * 3,
    margin : 24
  }
});

function isBlank(value) {
  return (_.isEmpty(value) && !_.isNumber(value)) || _.isNaN(value);
}

const StatsFilters = props => {
  const { onSubmit, classes } = props;
  return (
    <Formik
      initialValues={{ indicator: "", year: "", typing: "" }}
      onSubmit={values => {
        const cleanValues = _.omitBy(values, item => isBlank(item));
        onSubmit(cleanValues);
      }}
    >
      {({ values, handleSubmit, setFieldValue }) => (
        <Fragment>
          <Row className={classes.filters}>
            <Col xs={4}>
              <SelectDisease
                value={values.indicator}
                handleChange={(fileName, fieldValue) => {
                  setFieldValue("indicator", fieldValue);
                }}
                handleLoad={() => {}}
                storeIndicators={() => {}}
              />
            </Col>
            <Col xs={3}>
              <TypingFilter
                value={values.typing}
                handleChange={(fileName, fieldValue) => {
                  setFieldValue(fileName, fieldValue);
                }}
              />
            </Col>
            <Col xs={1}>
              <YearSelector
                value={values.year}
                handleChange={(fileName, fieldValue) => {
                  setFieldValue(fileName, fieldValue);
                }}
              />
            </Col>
          </Row>
          <Row end="xs">
            <Col xs={8}>
              <Button
                variant="outlined"
                onClick={handleSubmit}
                color="primary"
                className={classes.button}
              >
                Aplicar filtros
              </Button>
            </Col>
          </Row>
        </Fragment>
      )}
    </Formik>
  );
};

export default withStyles(styles)(StatsFilters);



// WEBPACK FOOTER //
// ./src/components/stats/filters.js